var module = angular.module('components');
module.component('caErrorList', {
    templateUrl: 'components/genericcomponents/errorlist.component.tpl.html',
    controllerAs: 'vm',
    bindings: {
        label: '<',
        errorList: '<',
        filterBy: '<'
    },
    scope: true,
    controller: [controller]
});

function controller($scope) {
    var vm = this;
    vm.$onChanges = onChanges;
    vm.$onInit = onInit;

    //Properties
    vm.filteredErrorList = vm.errorList;

    //Methods

    function onInit() {
        filterList();
    }

    function onChanges(changes) {
        if (changes.errorList) {
            filterList();
        }
    }

    function filterList() {
        vm.filteredErrorList = vm.errorList;
        if (vm.filterBy && vm.filterBy.length > 0) {
            vm.filteredErrorList = [];
            _.forEach(vm.errorList, function(error) {
                if (error.code && error.code === vm.filterBy) {
                    vm.filteredErrorList.push(error);
                }
            });
        }
    }
}
